'use client'
import React from 'react'
import {
    Stepper,
    StepperIndicator,
    StepperItem,
    StepperList,
    StepperSeparator,
    StepperTitle,
} from '@/components/ui/stepper'

type Step = {
    value: string
    title: string
}

interface Props {
    steps: Step[]
    currentStep: string
    className?: string
}

export default function CartStepper({ steps, currentStep, className }: Props) {
    return (
        <div className={className ?? 'w-3/4 m-auto'}>
            <Stepper value={currentStep} orientation="horizontal" dir={'inherit' as 'ltr' | 'rtl'}>
                <StepperList className="flex justify-center items-center">
                    {steps.map((step, index) => (
                        <StepperItem key={step.value} value={step.value}>
                            <div className="flex flex-col items-center">
                                <StepperIndicator>{index + 1}</StepperIndicator>
                                <StepperTitle className="text-center w-15 truncate">{step.title}</StepperTitle>
                            </div>

                            {index < steps.length - 1 && (
                                <StepperSeparator className="h-0.5 bg-gray-200 w-full mt-2 md:mx-6" />
                            )}
                        </StepperItem>
                    ))}
                </StepperList>
            </Stepper>
        </div>
    )
}
